export default __webpack_public_path__ + "static/media/poster-professional.be9ccb16.png";